import { useTheme } from "../../context/useThemeContext";
import { RightHeader } from "../header";
import { CustomScrollBox } from "../../components/customScrollBox";
import useMainStore from "../../stores/mainStore";
import RichTextFooter from "./RichTextFooter";
import { TipTap } from "../tipTap";
import TableOfContents from "./tableOfContents";
import RichTextHeader from "./richTextHeader/richTextHeader";
import { useEffect } from "react";
import useDataStore from "../../stores/dataStore";

function RightContent() {
    const { theme } = useTheme();
    // return null;
    

    return (
        <div
            className="flex flex-col flex-1 "
            style={{
                height: "inherit",
            }}
        >
            <RightHeader />
            <RichTextHeader />
            <div
                id="notes-container"
                className="flex flex-1 flex-col relative"
                style={{
                    backgroundColor: theme.mainContentColor,
                }}
            >
                <div className="absolute top-0 bottom-0 left-0 right-0 overflow-hidden mx-1 mt-1">
                    <TextEditor />
                    <TableOfContents />
                </div>
            </div>
            <RichTextFooter />
        </div>
    );
}

function TextEditor() {
    const { theme } = useTheme();
    const selectedNoteID = useMainStore((state) => state.data.selectedNoteID);

    useEffect(() => {
        // If selected note doesn't exist, set selected note to undefined
        if (!useDataStore.getState().data.notes[selectedNoteID]) {
            useMainStore.getState().set.selectedNoteID(() => undefined);
        }
    }, [selectedNoteID]);

    if (!selectedNoteID || !useDataStore.getState().data.notes[selectedNoteID])
        return (
            <div
                className="w-full h-full flex items-center justify-center text-sm"
                style={{
                    color: theme.fontColor[200],
                }}
            >
                Select a Note
            </div>
        );

    return (
        <CustomScrollBox
            $trackColor={theme.leftSidebarColor}
            $handleColor={theme.headerColor}
            $handleColorActive={theme.headerColor}
            className="flex flex-1 overflow-hidden h-full relative"
            id="scroll-content"
        >
            <TipTap />
        </CustomScrollBox>
    );
}

export default RightContent;
